import * as React from 'react';
import escapeRegExp from 'lodash-es/escapeRegExp';

export const MAX_TERM_LENGTH = 100;
export const Embolden = ({ children = '', term = '' }) => {
  if (!term.trim() || !children) {
    return <span>{children}</span>;
  }
  const targetTerm = term.substring(0, MAX_TERM_LENGTH);
  const regex = new RegExp(`(${escapeRegExp(targetTerm)})`, 'gi');
  const parts = children.split(regex);
  return (
    <span>
      {parts
        .filter(Boolean)
        .map((part, i) =>
          regex.test(part) ? <b key={i.toString()}>{part}</b> : <span key={i.toString()}>{part}</span>
        )}
    </span>
  );
};
